import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ProjectType, ProjectTypeService as SDKProjectTypes } from '@adeo/ngx-kozikaza-api';
import { map } from 'rxjs/operators';

@Injectable()
export class ProjectTypesResolver  {
  constructor(
    private readonly sdkProjectTypesService: SDKProjectTypes
  ) {}

  resolve(): Observable<ProjectType[]> {
    return this.sdkProjectTypesService.getProjectTypes(null).pipe(map((data) => data['hydra:member']));
  }
}
